import { useTranslation } from "react-i18next";
import { AUTOCOMPLETE_OPTION_LIMIT } from "@/constants/renderLimits";

/** Helper text for a group picker that `groupFilterOptions` cuts; undefined when every option fits. */
export function useGroupPickerHint(optionCount: number): string | undefined {
  const { t } = useTranslation();
  return optionCount > AUTOCOMPLETE_OPTION_LIMIT
    ? t("common.optionsLimited", { count: AUTOCOMPLETE_OPTION_LIMIT })
    : undefined;
}
